import { call, put, select, takeEvery } from "redux-saga/effects"

import {
  GET_ALL_INVESTMENT_LEADS,
  GET_INVESTMENT_LEAD_DETAILS,
  CREATE_INVESTMENT_LEAD,
  UPDATE_INVESTMENT_LEAD,
  DELETE_INVESTMENT_LEAD,
} from "./actionTypes"

import { get, post, ApiPut, del } from "helpers/api_helper"
import { Notification } from "../../components/Common/Notification"
import {
  createInvestmentLeadFail,
  createInvestmentLeadSuccess,
  deleteInvestmentLeadFail,
  deleteInvestmentLeadSuccess,
  getAllInvestmentLead,
  getAllInvestmentLeadFail,
  getAllInvestmentLeadSuccess,
  getInvestmentLeadDetailsFail,
  getInvestmentLeadDetailsSuccess,
  updateInvestmentLeadFail,
  updateInvestmentLeadSuccess,
} from "./actions"

//   - This line cannot be edited or removed
function getInvestmentLeadApi({ page, limit, searchText, filters }) {
  return get(
    `/investment-lead/admin/all/?page=${page ? page : 1}&limit=${limit ? limit : 10
    }&search=${searchText ? searchText : ""}&status=${filters?.sort ?? ""
    }&medium=${filters?.medium ?? ""}&type=${filters.type ?? ""}&leadCondition=${filters?.leadCondition ?? ""
    }&singleDate=${filters?.singleDate ?? ""}&from=${filters?.from ?? ""}&to=${filters?.to ?? ""}`
  )
}

const getInvestmentLeadDetailsAPi = clientId => {
  return get(`/investment-lead/admin/${clientId}`)
}

const createInvestmentLeadApi = ({ investmentLeads }) => {
  return post("/investment-lead/admin/new", investmentLeads)
}

const updateInvestmentLeadApi = ({ investmentLeads, investmentLeadId }) => {
  return ApiPut(`/investment-lead/admin/${investmentLeadId}`, investmentLeads)
}

const deleteInvestmentLeadApi = ({ investmentLeadId }) => {
  console.log(investmentLeadId)

  return del(`/investment-lead/admin/${investmentLeadId}`)
}

function* fetchInvestmentLead({ payload }) {
  try {
    const response = yield call(getInvestmentLeadApi, payload)
    yield put(getAllInvestmentLeadSuccess(response))
  } catch (error) {
    yield put(getAllInvestmentLeadFail(error))
  }
}

function* fetchInvestmentLeadDetails({ payload: clientId }) {
  try {
    const response = yield call(getInvestmentLeadDetailsAPi, clientId)
    yield put(getInvestmentLeadDetailsSuccess(response))
  } catch (error) {
    yield put(getInvestmentLeadDetailsFail(error))
  }
}

function* onCreateInvestmentLead({ payload }) {
  try {
    const response = yield call(createInvestmentLeadApi, payload)

    yield put(createInvestmentLeadSuccess(response))
    payload?.onCloseClick()
    doneNotification("Investment Lead Created Successfully!")
  } catch (error) {
    console.log(error)
    if (error?.response?.data?.message) {
      Notification({
        type: "error",
        message: error?.response?.data?.message,
        title: "",
      })
    }
    if (error?.response?.status === 413) {
      Notification({
        type: "error",
        message: "file size is Too Large",
        title: "",
      })
    }
    yield put(createInvestmentLeadFail(error))
  }
}

function* onUpdateInvestmentLead({ payload }) {
  try {
    const response = yield call(updateInvestmentLeadApi, payload)
    if (response) {
      Notification({
        type: "success",
        message: "Investment Lead Updated Successfully!",
        title: "",
      })
      yield put(updateInvestmentLeadSuccess(response))
      payload?.onCloseClick()

      const lastFetchParams = yield select(state => state.InvestmentLead?.lastFetchParams)
      if (lastFetchParams) {
        yield put(
          getAllInvestmentLead(
            lastFetchParams.page,
            lastFetchParams.limit,
            lastFetchParams.searchText,
            lastFetchParams.filters
          )
        )
      }
    }
  } catch (error) {
    if (error.response?.data?.message) {
      Notification({
        type: "error",
        message: error.response?.data?.message,
        title: "",
      })
    }
    if (error?.response?.status === 413) {
      Notification({
        type: "error",
        message: "file size is Too Large",
        title: "",
      })
    }
    yield put(updateInvestmentLeadFail(error.response.data))
  }
}

function* onDeleteInvestmentLead({ payload }) {
  try {
    const response = yield call(deleteInvestmentLeadApi, payload)
    yield put(deleteInvestmentLeadSuccess(response))
    payload?.onClose({ status: false, id: "" })
    doneNotification("Lead Deleted Successfully!")
  } catch (error) {
    if (error?.response?.data?.message) {
      Notification({
        type: "error",
        message: error?.response?.data?.message,
        title: "",
      })
    }
    yield put(deleteInvestmentLeadFail(error?.response?.data))
  }
}

function* InvestmentLeadSaga() {
  yield takeEvery(GET_ALL_INVESTMENT_LEADS, fetchInvestmentLead)
  yield takeEvery(GET_INVESTMENT_LEAD_DETAILS, fetchInvestmentLeadDetails)
  yield takeEvery(CREATE_INVESTMENT_LEAD, onCreateInvestmentLead)
  yield takeEvery(UPDATE_INVESTMENT_LEAD, onUpdateInvestmentLead)
  yield takeEvery(DELETE_INVESTMENT_LEAD, onDeleteInvestmentLead)
}

export default InvestmentLeadSaga

function doneNotification(message) {
  Notification({
    type: "success",
    message: message,
    title: "",
  })
}
